export type OverridableButtonTypes = 'embedded' | 'test';

export type EnhancedButtonTypeObject<T extends string> = {
  default: T;
} & Partial<Record<OverridableButtonTypes, T>>;

export type EnhancedButtonType<T extends string> = T | EnhancedButtonTypeObject<T>;

export const getEnhancedButtonType = <T extends string>(type?: EnhancedButtonType<T>): T | undefined => {
  if (!type) {
    return;
  }
  if (typeof type === 'string') {
    return type;
  }
  return type.embedded;
};
